<template>
  <div class="wrapper">
    <Header></Header>
    <div class="parkingSpace">
      <div class="header">
        <div>
          <span class="date">{{ roomInfo.date && moment(roomInfo.date).format('YYYY年MM月DD日') }}</span>
          <span class="time">{{ time }}</span>
        </div>
        <p class="carTitle">
          <span class="park">
            {{ $t('appointment.visitors.parking.space' + roomInfo.index) }}
          </span>

          <span class="selectTips">{{ $t('appointment.visitors.car.time.tips') }}</span>
        </p>
      </div>
      <TimeSelect :value="roomInfo.room" @onChange="handleChangeTime" />
      <div class="button">
        <Button color="#00CCBF" @click="submit" block>
          {{ $t('common.submit') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import TimeSelect from './timeSelect.vue';
import { Button } from 'vant';
import Header from '@/components/header.vue';

export default {
  components: {
    TimeSelect,
    Button,
    Header,
  },
  // props: ['date', 'type'],
  data() {
    return {
      moment,
      time: '', //实时显示选择时间
      periodValues: [],
      booking: [],
      start: '',
      end: '',
      updateInfo: [],
    };
  },
  computed: {
    roomInfo() {
      const roomInfo = localStorage.getItem('roomInfo');
      return (roomInfo && JSON.parse(roomInfo)) || {};
    },
    // date() {
    //   return this.$route.query.date;
    // },
    // authorId() {
    //   return this.$route.query.authorId;
    // },
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
    initInfo() {
      const infoStore = localStorage.getItem('infoStore');
      const data = (infoStore && JSON.parse(infoStore)) || {};
      return data;
    },
    // room() {
    //   return this.$route.query.room;
    // },
    // roomInfo() {
    //   return this.$store.state.visitor.visitorInMonthItem || [];
    // },

    // roomIndex() {
    //   return this.$route.query.index;
    // },
  },
  methods: {
    handleChangeTime(values, lastLabel) {
      this.time = values[0] + '-' + lastLabel[0];
      this.start = values[0];
      this.end = lastLabel[0];
    },
    transHourMSecond(val) {
      return val * 60 * 60 * 1000;
    },
    transMinuteMSecond(val) {
      return val * 60 * 1000;
    },
    submit() {
      const _this = this;
      const { cars } = this.initInfo;
      // if (!cars) {
      //   const infoStore = localStorage.getItem('infoStore');
      //   this.info = infoStore && JSON.parse(infoStore);
      // }
      const newCars = cars.map(i => {
        return {
          ...i,
          park: _this.roomInfo.index,
        };
      });

      _this.initInfo.cars = newCars;

      const startArr = _this.start.split(':');
      const endArr = _this.end.split(':');
      const start = _this.roomInfo.date + _this.transHourMSecond(startArr[0]) + _this.transMinuteMSecond(startArr[1]);
      const end = _this.roomInfo.date + _this.transHourMSecond(endArr[0]) + _this.transMinuteMSecond(endArr[1]);
      _this.initInfo.visitorInfoExtra.begin = +start;
      _this.initInfo.visitorInfoExtra.end = +end;
      this.updateInfo = _this.initInfo;
      this.$store.commit('visitor/updateVisitorApplyInfo', _this.initInfo);
      this.setStore(_this.initInfo);
      this.$router.push({ name: 'appointment' });
      // this.$router.push({ name: 'appointment', query: { authorId: this.authorId } });
    },
    setStore(val) {
      const infoStore = localStorage.getItem('infoStore');
      if (infoStore) {
        localStorage.setItem('infoStore', JSON.stringify(val));
      } else {
        localStorage.removeItem('infoStore');
        localStorage.setItem('infoStore', JSON.stringify(val));
      }
    },
  },
  created() {
    this.updateInfo = this.initInfo;
  },
  beforeDestroy() {
    this.$store.commit('visitor/updateVisitorApplyInfo', this.applyInfo);
    this.setStore(this.updateInfo);
    // const _this = this;
    // const infoStore = localStorage.getItem('infoStore');

    // if (!infoStore) {
    //   localStorage.setItem('infoStore', JSON.stringify(_this.applyInfo));
    // } else {
    //   localStorage.removeItem('infoStore');
    //   localStorage.setItem('infoStore', JSON.stringify(_this.applyInfo));
    // }
  },
};
</script>

<style lang="less" scoped>
.parkingSpace {
  padding: 30px 20px 130px;

  .header {
    font-size: 32px;
    text-align: left;

    .date {
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #363d4d;
      letter-spacing: 0.8px;
      line-height: 38px;
    }
    .time {
      margin-left: 30px;
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #363d4d;
      letter-spacing: 0.8px;

      line-height: 38px;
    }
    .carTitle {
      // color: #3d424d;
      margin: 22px 20px 40px 0;
      .park {
        font-family: PingFangSC-Regular;
        font-size: 32px;
        color: #3d424d;
        letter-spacing: 0;
        line-height: 38px;
      }
      .selectTips {
        opacity: 0.2;
        font-size: 24px;
        color: #000000;
        margin-left: 20px;
      }
    }
  }
  .button {
    position: fixed;
    height: 98px;
    bottom: 0;
    left: 0;
    right: 0;
    // background-color: white;
    // padding: 20px 30px 0px;
    padding: 20px 20px 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
